import './gryffEditor';
import './gfDraggable.ts';
import './gfModal';
import './gfModalNew';
import './gfHistory';
import './gfTooltips';
import './gfTooltipsNew';
import './gfGuide';
import './gfCount';
import './gfLoader';
import './gfCheckBrowser';
import './gfOnboarding';
import './gfShortcut';

import type { TypeShopResponse, TypePageResponse } from '@/app/types/editor/respon';
import type { TypeShop } from '@/app/types/editor/shop';
import type { TypePage } from '@/app/types/editor/page';
import { GET } from '@/app/api/index';

import store from '@/app/store/store';
import getParameterByName from '@/app/utils/getParameterByName';
import config from '@/app/editor/config/index';

import NewWebSocket from '@/app/socket/websocket.js';
import { checkKeyValid } from '@/app/utils/checkRoleApply';
import { BUILDER_OPEN_NEW_TAB } from '@/constants/feature-flag-key';
import { getEmbedAppUrl } from '@/utils/getEmbedAppUrl';
import { postMessageToParent } from '@/app/utils/helpers';

type ShopInfoParam = {
  global_configs?: boolean;
  store_info?: boolean;
  // otherKey?: number
  // otherKey?: string
};

/**
 *
 */
export class Wapper {
  /**
   * Init wrapper
   */
  public async Init(): Promise<undefined> {
    const page = await this.getPageInfo();
    if (page) {
      page.page.page = encodeURI(page.page.page);
      store.setValue('__page', page);
    }

    let interval = -1;
    if (window.__initRunning) {
      await new Promise((resolve) => {
        clearInterval(interval);
        interval = setInterval(() => {
          if (!window.__initRunning) {
            clearInterval(interval);
            resolve(true);
          }
        }, 10);
      });
    }
    if (window.___gemShopInfo) {
      const shop = window.___gemShopInfo;
      this.initWithShop(shop);
      return;
    }
    const params: ShopInfoParam = {
      global_configs: true,
      store_info: true,
    };
    const shop = await this.getShopInfo(params);
    if (shop) {
      this.initWithShop(shop);
    }
    return;
  }

  /**
   * init with shop
   * @param shop ...
   * @returns void ..
   */
  private initWithShop(shop: TypeShop) {
    if (!shop) {
      return;
    }
    store.setValue('__shop', shop);
    const socketObj = new NewWebSocket();
    socketObj.connect(shop.shopifyDomain);
    window._webSocket = socketObj;
    const globalConfig = shop['globalConfigs'];
    if (globalConfig) {
      try {
        const globalConfigObject = JSON.parse(globalConfig);
        store.setValue('__globalConfig', globalConfigObject);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
      }
    }
  }

  /**
   * Get shop information from shopify
   * @param params params value ShopInfoParam eg { "key1":"value 1", "key2":true, "key3": 123 }
   * @returns {Promise<TypeShop>} progress status
   */
  private async getShopInfo(params?: ShopInfoParam): Promise<TypeShop> {
    try {
      const req = await GET('/api/admin/me', params);
      if ((req.data as TypeShopResponse).status == 'success') {
        return (req.data as TypeShopResponse).data;
      } else {
        window.location.href = config.domain() + '/login';
        return null;
      }
    } catch (e) {
      const website = config.websiteDomain();
      const server = config.serverDomain();
      try {
        const resJSON = e.xhr.responseJSON;
        if (e.xhr.status == 401) {
          if (resJSON.code == 'apC00000') {
            const url = `${website}/api/admin/me?reAuth=true`;
            const resGetToken = await GET(url);
            let token = '';
            let shop = '';
            const resGetTokenJSON = resGetToken.xhr.responseJSON;
            if (resGetTokenJSON && resGetTokenJSON.data && resGetTokenJSON.data.shopifyDomain) {
              shop = resGetTokenJSON.data.shopifyDomain;
            }
            if (resGetTokenJSON && resGetTokenJSON && resGetTokenJSON.data && resGetTokenJSON.data.token) {
              token = resGetTokenJSON.data.token;
            }
            // Re Auth
            const urlReAuth = `${server}/re-auth`;
            const headers = {
              'X-GP-STORE': shop,
              'X-GP-TOKEN': token,
            };
            await GET(urlReAuth, undefined, undefined, undefined, undefined, undefined, headers);
            window.location.reload();
          } else {
            window.location.replace(website);
          }
        } else {
          window.location.replace(website);
        }
      } catch (e) {
        window.location.replace(website);
      }
      return null;
    }
  }

  /**
   * Get editing page information from database
   * @returns {Promise<TypeShop>} progress status
   */
  private async getPageInfo(): Promise<TypePage> {
    try {
      // https://gempages.net/editor?id=57879101499&page=refund&shop=dachai.myshopify.com&type=template-page
      let pageID = getParameterByName('id');
      const pageType = getParameterByName('type');
      const shopifyDomain = getParameterByName('shop') ?? '';

      if (!pageID) {
        pageID = '51460767821';
      }
      const req = await GET(
        `/api/editor/pages/${pageID}?type=${pageType}`,
        undefined,
        undefined,
        'application/x-www-form-urlencoded; charset=UTF-8',
        {
          headers: {
            'Cache-Control': 'no-cache',
          },
        },
      );
      if ((req.data as TypePageResponse).status == 'success') {
        return (req.data as TypePageResponse).data;
      } else {
        if (checkKeyValid(BUILDER_OPEN_NEW_TAB)) {
          const url = getEmbedAppUrl(shopifyDomain);
          if (window.top) {
            window.top.location.href = url;
          } else {
            window.location.href = url;
          }
          return null;
        }

        postMessageToParent({ type: 'windowCloseBuilder' });
        return null;
      }
    } catch (e) {
      return null;
    }
  }
}
